import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { banRoleLogin } from "@/api/role";
import { getGameServerMap } from "@/utils/dictionary";
export default {
  props: {
    serverId: String,
    roleId: String
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getGameServerMap();
          case 2:
            _this.serverList = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  data: function data() {
    return {
      hour: 60 * 60,
      day: 24 * 60 * 60,
      year: 365 * 24 * 60 * 60,
      serverList: {},
      formData: {
        server_id: this.serverId,
        role_list: [this.roleId],
        time: 86400,
        ban_reason: ""
      }
    };
  },
  watch: {},
  methods: {
    banRole: function banRole() {
      var _this2 = this;
      // 检查输入时间是否有效，是否有超出范围
      var time = Math.round(this.formData.time);
      if (isNaN(time) || time <= 0) {
        this.$message({
          type: "error",
          message: "封禁时间必须为正数"
        });
        return;
      }
      if (time > 50 * this.year) {
        this.$message({
          type: "error",
          message: "封禁时间不能超过50年"
        });
        return;
      }
      banRoleLogin(this.formData).then(function (res) {
        if (res.code == 0) {
          _this2.$emit("banFinish");
        }
      });
    },
    setTime: function setTime(seconds) {
      this.formData.time = String(seconds);
    },
    setBanReason: function setBanReason(data) {
      this.formData.ban_reason = data;
    }
  }
};